let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("ePjFZ")).then(() => parcelRequire('lFdRG'));